import { UnitType } from '@exodus/currency'

import _tokens from './tokens.js'
import { extractUnits } from './utils.js'

const name = 'algorand'
const displayName = 'Algorand'
const ticker = 'ALGO'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#D2D2D2'
const gradientColors = ['#ECECEC', '#B9B9B9']
const gradientCoords = { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' }
const chainBadgeColors = ['#FFFFFF', '#EAEAEA']

const units = {
  microAlgo: 0,
  ALGO: 6,
}
const currency = UnitType.create(units)

const assetType = 'ALGORAND_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://allo.info/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://allo.info/tx/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Algorand is a high performance blockchain based on next generation technology that implements a Proof of Stake protocol. The project has been called “Blockchain 3.0”, as it is able to solve the well-known problem of scalability found in Bitcoin, while maintaining decentralization and security.',
  reddit: 'https://www.reddit.com/r/algorand/',
  twitter: 'https://twitter.com/AlgoFoundation',
  website: 'https://algorand.foundation/',
  telegram: 'https://t.me/AlgorandFoundation',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export const algorand = asset

export const tokens = _tokens.map((token) => {
  const units = extractUnits(token)
  return {
    ...token,
    // name,
    // displayName,
    // decimals,
    // ticker,
    // assetIndex,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetId: String(token.assetIndex),
    assetType: 'ALGORAND_TOKEN',
    baseAssetName,
    blockExplorer,
    chainBadgeColors: token.chainBadgeColors || token.gradientColors,
    currency: UnitType.create(units),
    displayNetworkName,
    displayNetworkTicker,
    displayTicker: token.displayTicker || token.ticker,
    info: token.info || {},
    properName: token.displayName, // deprecated
    properTicker: token.displayTicker || token.ticker, // deprecated
    toString: () => token.name,
    units,
  }
})

export default [asset, ...tokens]
